<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i>
          <span style="margin-left: 5px">AI质检看板</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <div class="app-container">
        <FilterCommon :model="model" :isReset="true" @search="search" @reset="reset"></FilterCommon>

        <div class="dash-grid" v-loading="summaryLoading">
          <div class="metric">
            <div class="n">{{ summary.total_conversation_count }}</div>
            <div class="t">总会话量</div>
            <div class="sub">有效会话数 {{ summary.effective_conversation_count }}</div>
          </div>
          <div class="metric">
            <div class="n">{{ summary.ai_hit_count }}</div>
            <div class="t">AI命中数</div>
            <div class="sub">AI命中率 {{ summary.ai_hit_rate }}</div>
          </div>
          <div class="metric">
            <div class="n">{{ summary.manual_confirm_effective_count }}</div>
            <div class="t">人工确认有效数</div>
            <div class="sub">人工确认有效率 {{ summary.manual_confirm_effective_rate }}</div>
          </div>
          <div class="metric">
            <div class="n">{{ summary.appeal_pass_count }}</div>
            <div class="t">申诉通过数</div>
            <div class="sub">申诉通过率 {{ summary.appeal_pass_rate }}</div>
          </div>
        </div>

        <div class="card">
          <div class="sec-title">标签分布</div>
          <div v-loading="labelLoading">
            <div v-for="item in labelDistribution" :key="item.label" class="chart-row">
              <div class="chart-row-label">{{ item.label }}</div>
              <div class="chart-row-bar"><span :style="{ width: item.rate }"></span></div>
              <div class="chart-row-value">{{ item.count }}｜{{ item.rate }}</div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="sec-title">客服问题排行</div>
          <el-table :data="customerServiceRank" border v-loading="rankLoading">
            <el-table-column prop="city_name" label="地区" />
            <el-table-column prop="responsible_admin_name" label="负责客服" />
            <el-table-column prop="confirmed_count" label="已确认问题数" />
            <el-table-column prop="appeal_pass_count" label="申诉通过数" />
          </el-table>
        </div>

        <div class="card">
          <div class="sec-title">质检数量排行</div>
          <el-table :data="countRank" border v-loading="rankLoading">
            <el-table-column prop="operator_name" label="质检账号" />
            <el-table-column prop="handle_total" label="处理总数" />
            <el-table-column prop="confirmed_count" label="已确认问题数" />
            <el-table-column prop="false_hit_count" label="误报数" />
            <el-table-column prop="remind_only_count" label="仅提醒数" />
            <el-table-column prop="appeal_pass_count" label="审核通过数" />
            <el-table-column prop="appeal_reject_count" label="审核驳回数" />
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FilterCommon from '@/components/common/Filter';
import {
  getQwAiQualityOptionsApi,
  getQwAiQualityDashboardSummaryApi,
  getQwAiQualityLabelDistributionApi,
  getQwAiQualityCustomerServiceRankApi,
  getQwAiQualityCountRankApi,
} from '@/api/qwAiQuality';
import { normalizeQwAiQualityOptions } from './constants';
import dayjs from 'dayjs';

export default {
  components: { FilterCommon },
  data() {
    return {
      options: {},
      summaryLoading: false,
      labelLoading: false,
      rankLoading: false,
      summary: {},
      labelDistribution: [],
      customerServiceRank: [],
      countRank: [],
      query: {},
    };
  },
  computed: {
    model() {
      return [
        {
          type: 'date-picker',
          label: '会话时间',
          key: 'date',
          dateType: false,
          pick: true,
          showDayWeek: true,
          span: 6,
        },
        {
          type: 'select',
          label: '主体',
          key: 'corpid',
          placeholder: '请选择主体，支持多选',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.corps,
        },
        {
          type: 'select',
          label: '地区',
          key: 'city_names',
          placeholder: '请选择地区',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.cities,
        },
        {
          type: 'select',
          label: '企微客服',
          key: 'contact_userids',
          placeholder: '支持模糊搜索，多选',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.contacts,
        },
        {
          type: 'select',
          label: '负责客服',
          key: 'responsible_admin_ids',
          placeholder: '支持模糊搜索，多选',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.admins,
        },
        {
          type: 'select',
          label: '标签',
          key: 'labels',
          placeholder: '请选择标签',
          isMultiple: true,
          clearable: true,
          span: 6,
          options: this.options.labels,
        },
        {
          type: 'select',
          label: '标签间关系',
          key: 'label_relation',
          placeholder: '或',
          span: 6,
          options: [
            { label: '或', value: 'or' },
            { label: '且', value: 'and' },
          ],
        },
      ];
    },
  },
  created() {
    this.getOptions();
    this.query = this.defaultQuery();
    this.fetchAll();
  },
  methods: {
    defaultQuery() {
      return {
        begin_date: dayjs(new Date() - 1000 * 60 * 60 * 24 * 7).format('YYYY-MM-DD'),
        end_date: dayjs(new Date()).format('YYYY-MM-DD'),
      };
    },
    async getOptions() {
      const data = await getQwAiQualityOptionsApi({ types: 'city,corp,contact,admin,label' });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.options = normalizeQwAiQualityOptions(data.data);
    },
    search(formData) {
      const query = Object.assign({}, formData);
      query.begin_date = formData.start_date || this.defaultQuery().begin_date;
      query.end_date = formData.end_date || this.defaultQuery().end_date;
      delete query.date;
      delete query.start_date;
      this.query = query;
      this.fetchAll();
    },
    reset() {
      this.query = this.defaultQuery();
      this.fetchAll();
    },
    fetchAll() {
      this.fetchSummary();
      this.fetchLabelDistribution();
      this.fetchRank();
    },
    async fetchSummary() {
      this.summaryLoading = true;
      const data = await getQwAiQualityDashboardSummaryApi(this.query);
      this.summaryLoading = false;
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.summary = data.data;
    },
    async fetchLabelDistribution() {
      this.labelLoading = true;
      const data = await getQwAiQualityLabelDistributionApi(this.query);
      this.labelLoading = false;
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.labelDistribution = data.data;
    },
    async fetchRank() {
      this.rankLoading = true;
      const [serviceRankRes, countRankRes] = await Promise.all([getQwAiQualityCustomerServiceRankApi(this.query), getQwAiQualityCountRankApi(this.query)]);
      this.rankLoading = false;
      if (serviceRankRes.code === 200) {
        this.customerServiceRank = serviceRankRes.data;
      }
      if (countRankRes.code === 200) {
        this.countRank = countRankRes.data;
      }
    },
  },
};
</script>

<style scoped>
.dash-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 20px;
}
.metric {
  padding: 18px;
  border: 1px solid #e6ebf2;
  background: #fff;
  border-radius: 4px;
}
.metric .n {
  font-size: 28px;
  font-weight: 700;
  color: #263447;
}
.metric .t {
  color: #8792a2;
  margin-top: 6px;
}
.metric .sub {
  margin-top: 8px;
  color: #409eff;
  font-size: 12px;
}
.card {
  background: #fff;
  border: 1px solid #dfe4ec;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 16px;
}
.sec-title {
  font-weight: 700;
  margin-bottom: 12px;
  color: #263447;
}
.chart-row {
  display: grid;
  grid-template-columns: 160px 1fr 100px;
  gap: 12px;
  align-items: center;
  margin: 12px 0;
}
.chart-row-bar {
  height: 16px;
  background: #edf2f8;
  border-radius: 10px;
  overflow: hidden;
}
.chart-row-bar span {
  display: block;
  height: 100%;
  background: #409eff;
  border-radius: 10px;
}
</style>
